<template>
    <div class="configurator-select-color" v-bind:id="groupId">
        <accordion :show="true">
            <div slot="header">{{ title }}</div>

            <div class="row mt-3 no-gutters">

                <div class="col-lg-6 ml-lg-2 ml-xl-3 mt-4 mt-lg-5 ml-4 mr-4 mb-lg-5" v-if="image">
                    <v-lazy-image :src="image" alt="bike picture" class="img-fluid mt-lg-5" />
                </div>
                <div class="col-lg-5 ml-lg-3 ml-xl-4 mb-4 mb-lg-5 ml-4 mr-4 mt-5 mt-lg-5">

                    <div v-for="(item, index) in groupData">
                        <div v-for="(itemData, indexData) in item" :category="itemData.Category" class="select-colors-groups mb-4">
                            <div v-if="itemData.Disabled">

                                <div v-if="info">
                                    <div class="alert alert-warning">
                                        <div class="container">
                                            <div class="alert-icon">
                                                <i class="material-icons">warning</i>
                                            </div>
                                            {{ $t('personalize.colorsInfoText') }}
                                        </div>
                                    </div>
                                </div>


                                <div v-if="itemData.Value" class="select-colors-groups-title">{{ itemData.Description }}</div>

                                <div v-if="itemData.Value">
                                    <div v-for="(itemDisabledData, indexDisabledData) in itemData.Value.text">
                                        <input type="text" disabled :value="itemDisabledData.Description" class="form-control disabled" />
                                    </div>
                                </div>
                            </div>

                            <div v-else v-for="(itemSelect, keySelect, indexSelect) in itemData.Value" class="select-colors-container">
                                <div class="select-colors-groups-title">{{ itemData.Description }}</div>

                                <div :id="'select_color_' + indexData"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </accordion>
    </div>
</template>

<script>
    import VLazyImage from "v-lazy-image";

    export default {
        name: 'SelectColor',
        props: {
            title: String,
            image: String,
            group: String
        },
        data() {
          return {
              groupData: [],
              loading: true,
              selectData: [],
              category: '',
              info: true
          }
        },
        components: {
            VLazyImage
        },
        computed: {
            groupId() {
                return this.group.replace(/ /gi, "_")
            }
        },
        methods: {
            getGroupData: function() {
                let params = new URLSearchParams();
                params.append('apikey', this.$apikey);
                params.append('apipassword', this.$apipassword);
                params.append('ConfigurationID', this.$parent.$parent.ConfigurationID);
                params.append('CustomerID', this.$parent.$parent.customerID);

                let values = [];
                let navState = false;
                let app = this;
                let parent = app.$parent;
                let errorCounter = 0;

                app.getGroupDataPost(app,parent,params,values,navState,errorCounter);
            },
            getGroupDataPost(app,parent,params,values,navState,errorCounter) {
                this.$http.post(this.$apiurl + '/api/GetGroupData/' + app.group, params)
                    .then(response => {
                        this.groupData.push(response.data['ReturnData']);

                        let returnData = response.data['ReturnData'];
                        if(returnData.length > 1) {
                            app.info = false;
                        }


                        $.each(response.data['ReturnData'], function(indexData, valueData) {
                            if(valueData.Value) {
                                $.each(valueData.Value, function(indexSelect, valueSelect) {
                                    $.each(valueSelect, function(indexItem, valueItem) {
                                        values = valueSelect;

                                        if(valueItem['Selected'] === true) navState = true;
                                        valueItem['Group'] = app.group+' - '+valueData['Category'];
                                    });
                                });

                                if(values[0]['Name'] && !valueData['Disabled']) app.buildSelect(indexData, values);
                            }
                        });

                        if(navState === true) parent.$parent.nav = true;
                        parent.$parent.loading = false;
                    })
                    .catch(error => {
                        if (error.response.status === 500) {
                            errorCounter++;
                            if(errorCounter<= 25) {
                                setTimeout(function () {
                                    app.getGroupDataPost(app,parent,params,values,navState,errorCounter);
                                }, 250)
                            } else {
                                parent.popupError = true;
                            }
                        } else {
                            parent.popupError = true;
                        }
                    })
                    .finally(() => this.loading = false);
            },
            onSelected: function(data, characteristic) {
                let app = this;
                let parent = app.$parent;
                let values = [];
                let errorCounter = 0;
                let params = new URLSearchParams();
                let selected = true;
                params.append('apikey', this.$apikey);
                params.append('apipassword', this.$apipassword);
                params.append('ConfigurationID', this.$parent.$parent.ConfigurationID);
                params.append('CustomerID', this.$parent.$parent.customerID);
                params.append('Characteristic', characteristic);
                params.append('Value', data['selectedData']['Name']);

                $('.select-colors-groups').css('opacity', '0.5');

                parent.popupError = false;
                parent.$parent.loading = true;

                app.onSelectedPost(app,parent,params,values,errorCounter,selected);
            },
            onSelectedPost(app,parent,params,values,errorCounter,selected) {
                this.$http.post(this.$apiurl + '/api/SetValue', params)
                    .then(response => {
                        app.groupData = [];
                        app.groupData.push(response.data['ReturnData']);

                        $.each(response.data['ReturnData'], function(indexData, valueData) {
                            if(valueData.Value) {
                                $.each(valueData.Value, function(indexSelect, valueSelect) {
                                    $.each(valueSelect, function(indexItem, valueItem) {
                                        values = valueSelect;

                                        valueItem['Group'] = app.group+' - '+valueData['Category'];
                                    });
                                });

                                if(values[0]['Name'] && !valueData['Disabled']) app.buildSelect(indexData, values);
                            }

                            if(!valueData['Disabled'] && valueData['NotSelected']) {
                              selected = false;
                            }
                        });

                        parent.bikeImage = response.data['TransferData']['Image'];
                        if(response.data['TransferData']['Price'])
                            parent.$parent.price = response.data['TransferData']['Price'].toFixed(2).replace('.', ',') + ' ' + parent.$parent.priceSymbol;

                        if(response.data['TransferData']['ConfigurationID'])
                            parent.$parent.ConfigurationID = response.data['TransferData']['ConfigurationID'];

                        $('.select-colors-groups').css('opacity', '1');

                        if(selected) {
                          parent.$parent.nav = true;
                          parent.$parent.step = 1;
                        } else {
                          parent.$parent.nav = false;
                          parent.$parent.step = 2;
                        }
                        app.$parent.$parent.loading = false;
                    })
                    .catch(error => {
                        if (error.response.status === 500) {
                            errorCounter++;
                            if(errorCounter<= 25) {
                                setTimeout(function () {
                                    app.onSelectedPost(app,parent,params,values,errorCounter);
                                }, 250)
                            } else {
                                parent.popupError = true;
                            }
                        } else {
                            parent.popupError = true;
                        }
                    })
            },
            buildSelect: function (id, data) {
                let selectedKey = null;
                let selectText = this.$i18n.t('personalize.selectColor');
                let app = this;
                let counter = 0;

                for(let i=0; i < data.length; i++)
                {
                    if(data[i]['Selected'] === true)
                    {
                        selectedKey = i;
                    }
                    data[i]['PriceSymbol'] = this.$parent.$parent.priceSymbol;
                }
                $('div[id^="select_color_"]').ddslick('destroy');

                let interVal = setInterval(function(){
                    if($("#select_color_" + id).length !== 0 || counter === 1000)
                    {
                        clearInterval(interVal);
                        $("#select_color_" + id).ddslick({
                            data: data,
                            defaultSelectedIndex: selectedKey,
                            selectText: selectText,
                            background: '#ffffff',
                            width: '100%',
                            onSelected: function(data){
                                app.onSelected(data, app.groupData[0][id]['Category']);
                            }
                        });
                    }
                    else {
                        counter++;
                    }
                })
            }
        },
        created() {
            this.getGroupData();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .toggle-switch-container {
        min-height: 310px;
    }
    .configurator-select-color .row {
        border: solid 1px #afb0af;
        background-color: #ffffff;
    }
    .configurator-select-color .select-colors-groups:first-child {
        margin-top: 0;
    }
    .configurator-select-color .select-colors-groups .select-colors-groups-title {
        font-size: 15px;
        font-weight: bold;
        line-height: 1.2;
        text-transform: uppercase;
        margin-bottom: 15px;
    }
    .configurator-select-color .select-colors-groups >>> .dd-container {
        max-width: 380px;
    }
    .configurator-select-color .select-colors-groups input.disabled {
        max-width: 380px;
        background: #eeefee;
        border: 1px solid #afb0af;
        padding: 8px 13px 8px 13px;
    }
    .configurator-select-color .alert.alert-warning {
        background-color: #ec7205;
    }

</style>